var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyDollarFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 99,
    viewBox: "0 0 78 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6562 37.1108C29.6562 40.4105 32.3316 43.0858 35.6313 43.0858H41.6064C44.9061 43.0858 47.5815 40.4105 47.5815 37.1108C47.5815 33.811 44.9061 31.1357 41.6064 31.1357H35.6313C32.3316 31.1357 29.6562 28.4604 29.6562 25.1606C29.6562 21.8609 32.3316 19.1855 35.6313 19.1855H41.6064C44.9061 19.1855 47.5815 21.8609 47.5815 25.1606",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6191 19.1853V10.2227",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6191 52.0485V43.0859",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4949 31.1351C68.4949 47.6353 55.1197 61.0105 38.6195 61.0105C22.1193 61.0105 8.74414 47.6353 8.74414 31.1351C8.74414 14.635 22.1193 1.25977 38.6195 1.25977C55.1197 1.25977 68.4949 14.635 68.4949 31.1351Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6191 61.0098V97.259",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9372 67.8877C19.0859 68.3643 20.1166 69.0305 21.0368 69.8147C24.2857 72.5842 24.8115 76.6188 23.4612 79.8782C22.1108 83.1361 18.8858 85.6173 14.6315 85.2782C13.426 85.1826 12.2266 84.9242 11.0763 84.4492C3.75987 81.4183 1.25781 70.6811 1.25781 70.6811C1.25781 70.6811 10.6193 64.8569 17.9372 67.8877Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4609 79.877L25.3177 80.2429C33.0464 81.7666 38.6182 89.3818 38.6182 97.2584",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3016 67.8877C58.1528 68.3643 57.1221 69.0305 56.202 69.8147C52.953 72.5842 52.4272 76.6188 53.7776 79.8782C55.128 83.1361 58.353 85.6173 62.6073 85.2782C63.8127 85.1826 65.0122 84.9242 66.1624 84.4492C73.4789 81.4183 75.981 70.6811 75.981 70.6811C75.981 70.6811 66.618 64.8569 59.3016 67.8877Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7764 79.877L51.9197 80.2429C44.1909 81.7666 38.6191 89.3818 38.6191 97.2584",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 97.2598H64.5318",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 13.3333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyDollarFlower);
export default __webpack_public_path__ + "static/media/metodology-dollar-flower.a9a2f7486a340e89a014649b5be5516a.svg";
export { ForwardRef as ReactComponent };